import React, {Component} from 'react';
import '../../../styles/Home.css'
import {Link} from "react-router-dom";
import Panel from "../Panel";

export default class MojeBilety extends Component {

    render() {
        return <Panel>
            <div>
                <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Moje bilety</b></h4>
                <br/>
                <div className="row">
                    <div className="col-sm-6 text-center">
                        <Link to='/konto/bilety/jednorazowe'>
                            <div style={{
                                border: '1px solid #e0e0e0',
                                borderRadius: '10px',
                                textAlign: 'center',
                                padding: '10px'
                            }}>
                                <h2><i className="fa fa-ticket"> </i></h2>
                                <h3>Jednorazowe</h3></div>
                        </Link>
                    </div>

                    <div className="col-sm-6 text-center">
                        <Link to='/konto/bilety/miesieczne'>
                            <div style={{
                                border: '1px solid #e0e0e0',
                                borderRadius: '10px',
                                textAlign: 'center',
                                padding: '10px'
                            }}>
                                <h2><i className="fa fa-calendar"> </i></h2>
                                <h3>Miesięczne</h3></div>
                        </Link>
                    </div>
                </div>
            </div>
        </Panel>
    }

}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/MojeBilety.js